import HTTPBase from "@/api/HTTPBase.js"

let pwautils = {
    beforeinstallpromptEvent: null
}

pwautils.canInstalAsPWA = () => {
    window.console.log('PWA: canInstalAsPWA', pwautils.beforeinstallpromptEvent)
    return pwautils.beforeinstallpromptEvent ? true : false
}

pwautils.showInstallPrompt = async () => {
    if (!pwautils.beforeinstallpromptEvent) {
        window.console.log('showInstallPrompt llamado pero beforeinstallpromptEvent no se ha lanzado. Quizas la aplicacion esta ya instalada.')
        return
    }
    pwautils.beforeinstallpromptEvent.prompt()
    let res = await pwautils.beforeinstallpromptEvent.userChoice
    window.console.log(res)
    return res
}

pwautils.loadManifest = () => {
    let formID = HTTPBase.getFormIDFromURL();
    var link = document.createElement('link');
    link.rel = 'manifest';
    link.href = `${window.location.protocol}${process.env.VUE_APP_API_BASEURL}/dataset/catalog_forms/${formID}/pwaManifest`
    console.log('link.href', link.href )

    document.head.appendChild(link);
}

pwautils.loadManifest()
window.addEventListener('beforeinstallprompt', e => {
    window.console.log('PWA: confirmacion aplicacion instalable', e)
    pwautils.beforeinstallpromptEvent = e
})


/**
 * Indica si el navegador soporta notificaciones web push
 *
 * @returns
 */
pwautils.webPushIsSupported = () => 'Notification' in window
pwautils.webPushSubscription = null

/**
 *
 * @returns Solicita
 */
pwautils.webPushRequestPermission = async () => {
    window.console.log("subscribirseWebPush>", window.serviceWorker);
    const publicVapidKey =
        "BAXgepkeGwk6o6njAoLCHBZLIrUeW4Pzf6Z0J2FIsbcEpm2jTtkD8riUcZoQ0-sZLUgDx7AcRZu43umN4R5EhNY";

    let urlBase64ToUint8Array = (base64String) => {
        const padding = "=".repeat((4 - (base64String.length % 4)) % 4);
        const base64 = (base64String + padding)
            .replace(/-/g, "+")
            .replace(/_/g, "/");

        const rawData = window.atob(base64);
        const outputArray = new Uint8Array(rawData.length);

        for (let i = 0; i < rawData.length; ++i) {
            outputArray[i] = rawData.charCodeAt(i);
        }
        return outputArray;
    };

    window.console.log("waiting for acceptance>", window.serviceWorker);
    try {
        pwautils.webPushSubscription = await window.serviceWorker.pushManager.subscribe({
            userVisibleOnly: true,
            applicationServerKey: urlBase64ToUint8Array(publicVapidKey),
        });
    } catch (e) {
        window.console.warn('Error obteniendo permisos', e)
        if (Notification.permission === 'denied') {
            window.console.warn('Permission for notifications was denied');
        } else {
            window.console.error('Unable to subscribe to push', e);
        }
        window.console.error(e)
        throw e
    }
    window.console.log("webpush acceptance complete>", pwautils.webPushSubscription);

    return pwautils.webPushSubscription
}


pwautils.webPushServerSubscribe = (details) => {
    if (!pwautils.webPushSubscription) {
        window.console.log('Se ha pedido crear un suscriptor sin permisos')
        return
    }

    //let fn = stats.id ? window.api.axios.put : window.api.axios.post
    return HTTPBase.POST('/webpush/subscription', {
        subscriber: pwautils.webPushSubscription,
        alias: details.alias,
        creation_app: details.creation_app
    })
}

export default pwautils;
